<div class="elementsBar row">
    <div class="elementsBarBtns col-6">
        <button mat-button (click)="favouriteClick()" [style.color]="favColor" class="FavoriteButton">
            <svg class="pc-icon">
                <use xlink:href="assets/fonts/custom-icon.svg#star-colored"></use>
            </svg>
            {{ 'addtoFavorite' | translate }}
        </button>
    </div>
</div>